import { isObject } from '@utils/guards'
import { range } from 'rambda'
import { recaptchaKey } from '@config'

export default {
  store: {
    actions: {
      // TODO: fix authed users fetching state 2 times - once as a guest,
      // another time as a logged in user
      async FETCH_STATE({ dispatch, getters }) {
        const possibleFetches = [
          [getters.hasRole('>=USER'), 'USER'],
        ]

        const permittedFetches = possibleFetches
          .filter(([hasPermission]) => hasPermission)
          .map(([_, storeSuffix]) => storeSuffix)

        return Promise
          .all(permittedFetches
            .map(actionSuffix => [`FETCH_${actionSuffix}`, { $sort: { id: -1 } }])
            .map(([fetchName, fetchQuery]) => dispatch(fetchName, fetchQuery)))
      },
    },
    getters: {
      hasRecaptcha: () => !!recaptchaKey,

      splitIntoColumns: (_, { screenSizes }) => (entries, columnMap) => {
        const columnCountKey = Object.keys(columnMap).find(size => screenSizes.includes(size))
        const columnCount = columnMap[columnCountKey]
        return range(0, columnCount)
          .map((_, columnIndex) => entries
            .filter((_, index) => (index % columnCount) === columnIndex))
      },

      // TODO: rewrite in a similar fashion as splitIntoColumns
      splitIntoRows: (_, { screenSizes }) => (entries, columnMap) => {
        const columns = isObject(columnMap)
          ? columnMap[Object.keys(columnMap).find(size => screenSizes.includes(size))]
          : columnMap

        const keys = isObject(entries) ? Object.keys(entries) : null
        const iterable = (keys || entries)
        const rows = new Array(Math.ceil(iterable.length / columns))
          .fill()
          .map(() => [])

        iterable.forEach((entry, index) => {
          const row = rows[Math.floor(index / columns)]
          if (keys) {
            row[entry] = entries[entry]
          } else {
            row.push(entry)
          }
        })

        return rows
      },
    },
  },
}
